import { adaptiveLesson } from './adaptive-lesson/adaptiveLesson';
import { hesiAssess } from './hesi-assess/hesiAssess';
import { adaptiveQuiz } from './adaptive-quiz/adaptiveQuiz';
import { sherpathLesson } from './sherpath-lesson/sherpathLesson';
import { simchartCaseStudy } from './simchart-case-study/simchartCaseStudy';
import { simchartChart } from './simchart-chart/simchartChart';
import { simchart } from './simchart/simchart';
import { slsSimchartSimulationEhr } from './sls-simchart-simulation-ehr/slsSimchartSimulationEhr';
import { osmosisVideo } from './osmosis-video/osmosisVideo';
import { ebookReading } from './ebook-reading/ebookReading';
import { shadowHealthAssignment } from './shadow-health-assignment/shadowHealthAssignment';
import { mcqQuiz } from './mcq-quiz/mcqQuiz';

/**
 * An object containing the different types of assignments available in the application.
 * Each key represents a unique assignment type, mapped to its corresponding implementation.
 *
 * @remarks
 * Extend this object to add new assignment types as needed.
 */
export const ASSIGNMENT_TYPES = {
  ADAPTIVE_LESSON: adaptiveLesson,
  SIMCHART_CASE_STUDY: simchartCaseStudy,
  SIMCHART_CHART: simchartChart,
  SLS_SIMCHART_SIMULATION_EHR: slsSimchartSimulationEhr,
  SIMCHART: simchart,
  SIM_CHART: simchartCaseStudy,
  HESI_ASSESS: hesiAssess,
  ADAPTIVE_QUIZ: adaptiveQuiz,
  MCQ_QUIZ: mcqQuiz,
  SHERPATH_LESSON: sherpathLesson,
  OSMOSIS_VIDEO: osmosisVideo,
  EBOOK_READING: ebookReading,
  SHADOW_HEALTH_ASSIGNMENT: shadowHealthAssignment,
  // Alias: RecContentItemTypeDto.SHADOW_HEALTH and AssignmentType.SHADOW_HEALTH share this literal value
  SHADOW_HEALTH: shadowHealthAssignment,
  // The following types only define isScorable, so they are not separated into individual files
  MASTERY: { isScorable: true },
  QUIZ_BY_QUESTION: { isScorable: true },
  STANDARD: { isScorable: true },
  AUTHESS: { isScorable: true },
  LESSONS: { isScorable: true }
};
